import { apiClient } from '../../../api/client'
import { downloadXlsx } from '../../../lib/download'
import type { HolidayDay, HolidayDayPage, HolidayDayStatus, HolidayDayUpsert } from '../types'

const BASE = '/management/holiday-days'

/**
 * Silinmemiş kayıtların listesi (tarihe göre yeniden eskiye). Lookup ölçeği küçük → tek sayfa.
 *
 * `q` açıklamada arar ve **sunucuda** süzülür: TR-farkında karşılaştırma (`i` ↔ `İ`) orada yazılı,
 * istemcide ikinci bir kopyası tutulmaz.
 */
export async function getHolidayDays(q?: string): Promise<HolidayDayPage> {
  const { data } = await apiClient.get<HolidayDayPage>(BASE, {
    params: { page: 0, size: 200, ...(q ? { q } : {}) },
  })
  return data
}

/** Yeni kayıt (201 → oluşturulan kayıt). */
export async function createHolidayDay(body: HolidayDayUpsert): Promise<HolidayDay> {
  const { data } = await apiClient.post<HolidayDay>(BASE, body)
  return data
}

/** Kaydı güncelle (tarih/açıklama/yarım gün; optimistic lock için `modDate` zorunlu). */
export async function updateHolidayDay(id: number, body: HolidayDayUpsert): Promise<HolidayDay> {
  const { data } = await apiClient.put<HolidayDay>(`${BASE}/${id}`, body)
  return data
}

/** Durum değiştir (Aktif/Pasif; yalnız 0↔1). */
export async function changeHolidayDayStatus(
  id: number,
  body: HolidayDayStatus,
): Promise<HolidayDay> {
  const { data } = await apiClient.put<HolidayDay>(`${BASE}/${id}/status`, body)
  return data
}

/** Soft-delete (record_status=2). 204. */
export async function deleteHolidayDay(id: number): Promise<void> {
  await apiClient.delete(`${BASE}/${id}`)
}

/**
 * Listeyi Excel (.xlsx) olarak indirir; dosya adı sunucunun Content-Disposition'ından okunur.
 * Ekranda ne görünüyorsa o iner: arama metni dışa aktarıma da geçirilir.
 */
export async function exportHolidayDays(q?: string): Promise<void> {
  await downloadXlsx(`${BASE}/export`, q ? { q } : {}, 'tatil-gunleri.xlsx')
}
